import React from 'react'

import en from '../../../locales/en/translation.json';
import fr from '../../../locales/fr/translation.json';
import send from "../../../assets/logos/send_fr.svg";

export default class Partenaire extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'en',
            trad: en,
        }
    }

    render(){
        const {trad} = this.state;
        return(
            <div className="page_partenaire">
                <div className="titre">
                    <h1>Partenaire</h1>
                    <p className="baseline_partenaire">{trad.contactBaseline}</p>
                </div>
                <div className="formulaire_partenaire">
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact6}</label><br/>
                        <input onChange={(e) => this.setState({prenom: e.target.value})} value={this.state.prenom}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact1}</label><br/>
                        <input onChange={(e) => this.setState({prenom: e.target.value})} value={this.state.prenom}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact3}</label><br/>
                        <input onChange={(e) => this.setState({email: e.target.value})} value={this.state.email}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact7}</label><br/>
                        <select>
                            <option value="test_1">Test 1</option>
                            <option value="test_2">Test 2</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact8}</label><br/>
                        <textarea
                            onChange={(e) => this.setState({message: e.target.value})}>{this.state.message}</textarea>
                    </div>
                    <div className="form-group-edit">
                        <button onClick={this.handleSendMessage}>
                            <img src={send} alt=""/>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

}
